var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftToLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.375 233.75C99.125 240 96 248.188 96 256.375S99.125 272.75 105.375 279L255.824 414.908C286.691 442.793 336 420.887 336 379.289V336.375H400C426.508 336.375 448 314.885 448 288.375V224.375C448 197.865 426.508 176.375 400 176.375H336V133.088C336 91.457 286.629 69.564 255.773 97.512L105.375 233.75ZM288 224.375H400V288.375H288V377.742L150.633 256.375L288 135.008V224.375ZM48 424V88C48 74.75 37.25 64 24 64S0 74.75 0 88V424C0 437.25 10.75 448 24 448S48 437.25 48 424Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftToLine);
export default __webpack_public_path__ + "static/media/left-to-line.bad60e2197cd0fddafbada0a5965083d.svg";
export { ForwardRef as ReactComponent };